import { render, staticRenderFns } from "./QuestionVideo.vue?vue&type=template&id=cbff2560&scoped=true&"
import script from "./QuestionVideo.vue?vue&type=script&lang=js&"
export * from "./QuestionVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbff2560",
  null
  
)

export default component.exports